import React, { useEffect, useRef } from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Store from '../redux/store';
import '../resources/css/footer-bar.css';
import callWaiterIcon from '../assets/callWaiter.png';
import menuPageIcon from '../assets/menuPage.png';
import HomePageIcon from '../assets/home.png';
import orderCartIcon from '../assets/orderCart.png';
import CustomizedTooltips, { GuideTooltips } from './tooltip.component';
import HistoryIcon from '@material-ui/icons/History';
import { useSnackbar, withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import i18n from '../i18n';
import { StateManager } from '../redux/stateManager';
import { WebsocketClient } from '../websocket/module';
import { getCacheField } from '../tools/get-cache-field';
import { Fab, Zoom, Badge } from '@material-ui/core';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { UpdateCart } from '../websocket/cart2';
import useSetState from '../tools/hooks/useSetState';
import { getSettingInfo } from '../tools/get-setting-info';

const FooterBar = ({
    foodBarMode,
    customer,
    enqueueSnackbar,
    approvalStatus,
    onSetCartDrawer,
}: Props) => {
    const messengerModule = useRef(new MessengerModule(enqueueSnackbar));
    const guidePageHideDishes = StateManager.getFromCache('guidePageHideDishes');
    const approvalStatusRef = useRef(approvalStatus);
    const callDisabled = getSettingInfo('call_service_function', 'value')
    const getUpdateToolStatus = () => {
        if (getCacheField('approvalStatus') === 'NO' && customer.length === 0) {
            return false;
        }
        return getCacheField('guidePageHideDishes') ? true : false
    }
    const [state, setState] = useSetState<State>({
        // footer navigation item list
        footerNavList: [
            { viewPage: 'menuPage', icon: 'book-open-outline' },
            { viewPage: 'homePage', icon: 'clipboard-outline' },
            { viewPage: 'shoppingCartPage', icon: 'shopping-cart-outline' },
            { viewPage: 'orderHistory', icon: 'star-outline' },
            { viewPage: 'callWaiter', icon: 'radio-outline' },
        ],
        // View name
        viewPage: 'menuPage',
        // 购物车已解锁弹出提示
        setToolTip: false,
        updateToolTipStatus: getUpdateToolStatus(),
        zoomIn: ServerShoppingCart.getCurrentCustomerCart({})?.totalNum || 0,
        isUpdateCartAnimate: false,
    })

    const { viewPage, setToolTip, zoomIn, updateToolTipStatus, isUpdateCartAnimate } = state;
    const { closeSnackbar } = useSnackbar();

    useEffect(() => {
        if (approvalStatusRef.current !== approvalStatus) {
            approvalStatusRef.current = approvalStatus;
            // 审核通过提示购物车已解锁
            if (approvalStatusRef.current === 'APPROVED') {
                updateToolTip();
            }
        }
        // $ 分配顾客ID后
        WebsocketClient.addListener('BUBBLE_PROMPT', toolTipListener)
        // $ 监听连接购物车
        WebsocketClient.addListener('CONNECT_CART', connectCartListener);
        // $ 监听更新购物车
        WebsocketClient.addListener('UPDATE_CART', updateCartListener);
        // $ 监听断网重连
        WebsocketClient.addListener('CONNECT', updateCount);
        return () => {
            WebsocketClient.removeListener('BUBBLE_PROMPT', toolTipListener);
            WebsocketClient.removeListener('CONNECT_CART', connectCartListener);
            WebsocketClient.removeListener('UPDATE_CART', updateCartListener);
            WebsocketClient.removeListener('CONNECT', updateCount);
            // $ alwyas unsubscribe in un mount function
        }
    }, [approvalStatus])

    // *********************
    // 方法区
    // *********************
    // $ 监听更新购物车
    const updateCartListener = (data: UpdateCart) => {
        if (data?.data?.tableId === ServerShoppingCart?.metaData?.tableId) {
            setTimeout(() => {
                setState({
                    isUpdateCartAnimate: false,
                });
            }, 300)
            ServerShoppingCart.updateSeverShoppingCartModule(data.data);
            const zoomIn = ServerShoppingCart.getCurrentCustomerCart({})?.totalNum || 0;
            setState({
                zoomIn,
                isUpdateCartAnimate: true
            });
        }
    }
    // $ 连接购物车
    const connectCartListener = (data: UpdateCart) => {
        ServerShoppingCart.updateSeverShoppingCartModule(data.data);
        const zoomIn = ServerShoppingCart.getCurrentCustomerCart({})?.totalNum || 0;
        setState({ zoomIn });
    }

    // $更新购物车菜品数量
    const updateCount = () => {
        const zoomIn = ServerShoppingCart.getCurrentCustomerCart({})?.totalNum || 0;
        setState({
            zoomIn,
        });
    }


    // 监听用户选中ID
    const toolTipListener = () => {
        setState({
            updateToolTipStatus: true
        })
    }
    const pagesSwitch = (e: any, viewPage: ViewPageType) => {

        // 审核中不能点击购物车
        if (viewPage === 'shoppingCartPage' && Store.getState().approvalStatus === 'REVIEW') {
            messengerModule.current.say({
                message: `${i18n.t('menu_page_text_under_review_wait')}`,
                level: "Warning",
            });
            return;
        }
        if (viewPage === 'shoppingCartPage' && Store.getState().approvalStatus === 'APPROVED') {
            // 审核通过，点击购物车关闭已解锁
            setState({
                setToolTip: false
            })
        }
        closeSnackbar();

        setState({ viewPage });
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'viewPage',
            value: viewPage
        })

        if (viewPage !== 'menuPage') {
            Store.dispatch({
                type: 'SET',
                path: 'foodBarMode',
                value: 'MULTIPLE'
            })
        }

    }

    // 更新提示状态
    const updateToolTip = () => {
        // 审核通过弹出购物车已解锁
        setState({
            setToolTip: true
        })
        setTimeout(handleTooltipClose, 2500)

    }

    // 关闭已解锁
    const handleTooltipClose = () => {
        setState({
            setToolTip: false
        })
    }

    return (
        <div className={foodBarMode === 'MULTIPLE' ? 'bottomIcon' : 'bottomIcon active'}>
            {foodBarMode === 'MULTIPLE' ? (
                <BottomNavigation value={viewPage} onChange={(e, value) => pagesSwitch(e, value)}>
                    <BottomNavigationAction value="homePage" icon={
                        <GuideTooltips
                            onClose={() => {
                            }}
                            placement="top"
                            arrow
                            open={guidePageHideDishes}
                            title={i18n.t('novice_guide_text_home')}
                            toopTipStyle={{
                                popperIndex: updateToolTipStatus,
                                height: 30,
                            }}
                        >
                            <img src={HomePageIcon} alt="主页" width="24" />
                        </GuideTooltips>
                    } />
                    <BottomNavigationAction value="menuPage" icon={
                        <GuideTooltips
                            onClose={() => {
                            }}
                            placement="top"
                            arrow
                            open={guidePageHideDishes}
                            title={i18n.t('novice_guide_text_order')}
                            toopTipStyle={{
                                popperIndex: updateToolTipStatus,
                                height: 30,
                                maxWidth: 60
                            }}
                        >
                            <img src={menuPageIcon} alt="菜单" width="24" />
                        </GuideTooltips>
                    } />
                    <div
                        className={`MuiBottomNavigationAction-root ${!guidePageHideDishes ? 'hide-ripple' : ''} ${isUpdateCartAnimate ? 'animate-update-cart' : ''}`}
                        style={{ opacity: !!zoomIn ? 1 : 0.7 }}
                        onClick={() => { 
                            if (getCacheField('cartButtonLoading')) {
                                messengerModule.current.say({
                                    message: `${i18n.t('order_cart_page_text_is_submitting')}`,
                                    level: 'Warning',
                                });
                                return 
                            }
                            onSetCartDrawer(true) 
                        }}
                    >
                        {
                            guidePageHideDishes ?
                                <GuideTooltips
                                    onClose={() => {
                                    }}
                                    placement="top"
                                    arrow
                                    open={guidePageHideDishes}
                                    title={i18n.t('novice_guide_text_cart')}
                                    toopTipStyle={{
                                        popperIndex: updateToolTipStatus,
                                        height: 30,
                                    }}
                                >
                                    <img src={orderCartIcon} alt="购物车" width="24" />
                                </GuideTooltips> :
                                <div>
                                    <Zoom
                                        in={!!zoomIn}
                                        timeout={{
                                            enter: 300,
                                            exit: 300
                                        }}
                                        style={{
                                            transitionDelay: `${zoomIn ? 300 : 0}ms`,
                                        }}
                                        unmountOnExit
                                    >
                                        <Fab aria-label={'购物车'} style={{
                                            background: '#00cccc',
                                            border: '4px solid #3f4e86',
                                            position: 'absolute',
                                            left: 'calc(50% - 28px)',
                                            top: 'calc(50% - 36px)'
                                        }}>
                                            <Badge className='footer-bar-badge-total' overlap='rectangle' badgeContent={zoomIn}>
                                                <img src={orderCartIcon} alt="购物车" width="24" />
                                            </Badge>
                                        </Fab>
                                    </Zoom>
                                    <Zoom
                                        in={!zoomIn}
                                        timeout={{
                                            enter: 300,
                                            exit: 300
                                        }}
                                        style={{
                                            transitionDelay: `${!zoomIn ? 300 : 0}ms`,
                                        }}
                                        unmountOnExit
                                    >
                                        <Fab aria-label={'购物车'} style={{
                                            background: 'transparent',
                                            position: 'absolute',
                                            left: 'calc(50% - 28px)',
                                            top: 'calc(50% - 28px)',
                                            boxShadow: 'unset'
                                        }} >
                                            <img src={orderCartIcon} alt="购物车" width="24" />
                                        </Fab>
                                    </Zoom>
                                </div>
                        }
                    </div>
                    {/* <BottomNavigationAction className={`${!guidePageHideDishes ? 'hide-ripple' : ''} ${isUpdateCartAnimate ? 'animate-update-cart' : ''}`}
                        style={{ opacity: !!zoomIn ? 1 : 0.7 }} value="shoppingCartPage"
                        icon={
                            guidePageHideDishes ?
                                <GuideTooltips
                                    onClose={() => {
                                    }}
                                    placement="top"
                                    arrow
                                    open={guidePageHideDishes}
                                    title={i18n.t('novice_guide_text_cart')}
                                    toopTipStyle={{
                                        popperIndex: updateToolTipStatus,
                                        height: 30,
                                    }}
                                >
                                    <img src={orderCartIcon} alt="购物车" width="24" />
                                </GuideTooltips> :
                                <div>
                                    <Zoom
                                        in={!!zoomIn}
                                        timeout={{
                                            enter: 300,
                                            exit: 300
                                        }}
                                        style={{
                                            transitionDelay: `${zoomIn ? 300 : 0}ms`,
                                        }}
                                        unmountOnExit
                                    >
                                        <Fab aria-label={'购物车'} style={{
                                            background: '#00cccc',
                                            border: '4px solid #3f4e86',
                                            position: 'absolute',
                                            left: 'calc(50% - 28px)',
                                            top: 'calc(50% - 36px)'
                                        }}>
                                            <Badge className='footer-bar-badge-total' overlap='rectangle' badgeContent={zoomIn}>
                                                <img src={orderCartIcon} alt="购物车" width="24" />
                                            </Badge>
                                        </Fab>
                                    </Zoom>
                                    <Zoom
                                        in={!zoomIn}
                                        timeout={{
                                            enter: 300,
                                            exit: 300
                                        }}
                                        style={{
                                            transitionDelay: `${!zoomIn ? 300 : 0}ms`,
                                        }}
                                        unmountOnExit
                                    >
                                        <Fab aria-label={'购物车'} style={{
                                            background: 'transparent',
                                            position: 'absolute',
                                            left: 'calc(50% - 28px)',
                                            top: 'calc(50% - 28px)',
                                            boxShadow: 'unset'
                                        }} >
                                            <img src={orderCartIcon} alt="购物车" width="24" />
                                        </Fab>
                                    </Zoom>
                                </div>
                        } /> */}

                    <BottomNavigationAction value="orderHistory" icon={
                        <GuideTooltips
                            onClose={() => {
                            }}
                            placement="top"
                            arrow
                            open={guidePageHideDishes}
                            title={i18n.t('novice_guide_text_history')}
                            toopTipStyle={{
                                popperIndex: updateToolTipStatus,
                                height: 30,
                                maxWidth: 60
                            }}
                        >
                            <HistoryIcon />
                        </GuideTooltips>
                    } />
                    <BottomNavigationAction value="callWaiter" disabled={callDisabled === 0} icon={
                        <GuideTooltips
                            onClose={() => {
                            }}
                            placement="top"
                            arrow
                            open={guidePageHideDishes}
                            title={i18n.t('novice_guide_text_call')}
                            toopTipStyle={{
                                popperIndex: updateToolTipStatus,
                                height: 30,
                                maxWidth: 60
                            }}
                        >
                            <img src={callWaiterIcon} alt="呼叫服务员" width="24" />
                        </GuideTooltips>
                    } />
                </BottomNavigation>
            )
                :
                // <BottomNavigation value={viewPage} onChange={(e, value) => pagesSwitch(e, value)}>
                //     <BottomNavigationAction value="shoppingCartPage" icon={
                //         <CustomizedTooltips
                //             onClose={handleTooltipClose}
                //             placement="top"
                //             arrow
                //             disableFocusListener
                //             disableHoverListener
                //             disableTouchListener
                //             open={setToolTip}
                //             title={i18n.t('menu_page_text_order_unlocked')}
                //         >
                //             <img src={orderCartIcon} alt="购物车" width="24" />
                //         </CustomizedTooltips>
                //     }
                //     />
                // </BottomNavigation>
                <CustomizedTooltips
                    onClose={handleTooltipClose}
                    placement="top"
                    arrow
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    open={setToolTip}
                    title={i18n.t('menu_page_text_order_unlocked')}
                    onClick={() => { onSetCartDrawer(true) }}
                >
                    <img src={orderCartIcon} alt="购物车" width="24" />
                </CustomizedTooltips>
            }
        </div>
    )
}

// class FooterBar extends Component<Props, State> {
//     public messengerModule: MessengerModule;
//     constructor(props: Props) {
//         super(props);
//         this.state = {
//             // footer navigation item list
//             footerNavList: [
//                 { viewPage: 'menuPage', icon: 'book-open-outline' },
//                 { viewPage: 'homePage', icon: 'clipboard-outline' },
//                 { viewPage: 'shoppingCartPage', icon: 'shopping-cart-outline' },
//                 { viewPage: 'orderHistory', icon: 'star-outline' },
//                 { viewPage: 'callWaiter', icon: 'radio-outline' },
//             ],
//             // View name
//             viewPage: 'menuPage',
//             // 购物车已解锁弹出提示
//             setToolTip: false,
//             updateToolTipStatus: this.getUpdateToolStatus(),
//             zoomIn: ServerShoppingCart.getCurrentCustomerCart({})?.totalNum || 0
//         } as State
//         this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
//     };

//     // *********************
//     // 生命周期
//     // *********************
//     public componentDidMount() {
//         // $ 分配顾客ID后
//         WebsocketClient.addListener('BUBBLE_PROMPT', this.toolTipListener)
//         // $ 监听连接购物车
//         WebsocketClient.addListener('CONNECT_CART', this.connectCartListener);
//         // $ 监听更新购物车
//         WebsocketClient.addListener('UPDATE_CART', this.updateCartListener);
//     }

//     public async componentWillUnmount() {
//         WebsocketClient.removeListener('BUBBLE_PROMPT', this.toolTipListener);
//         WebsocketClient.removeListener('CONNECT_CART', this.connectCartListener);
//         WebsocketClient.removeListener('UPDATE_CART', this.updateCartListener);
//         // $ alwyas unsubscribe in un mount function
//     }

//     UNSAFE_componentWillReceiveProps(nextProps: Props) {
//         if (nextProps.approvalStatus !== this.props.approvalStatus) {
//             // 审核通过提示购物车已解锁
//             if (nextProps.approvalStatus === 'APPROVED') {
//                 this.updateToolTip();
//             }
//         }
//     }

//     // *********************
//     // 方法区
//     // *********************
//     // $ 监听更新购物车
//     public updateCartListener = (data: UpdateCart) => {
//         if (data?.data?.tableId === ServerShoppingCart?.metaData?.tableId) {
//             ServerShoppingCart.updateSeverShoppingCartModule(data.data);
//             const zoomIn = ServerShoppingCart.getCurrentCustomerCart({})?.totalNum || 0;
//             this.setState({ zoomIn });
//         }
//     }
//     // $ 连接购物车
//     public connectCartListener = (data: UpdateCart) => {
//         ServerShoppingCart.updateSeverShoppingCartModule(data.data);
//         const zoomIn = ServerShoppingCart.getCurrentCustomerCart({})?.totalNum || 0;
//         this.setState({ zoomIn });
//     }

//     public getUpdateToolStatus() {
//         const { customer } = this.props;
//         if (getCacheField('approvalStatus') === 'NO' && customer.length === 0) {
//             return false;
//         }
//         return getCacheField('guidePageHideDishes') ? true : false
//     }
//     // 监听用户选中ID
//     public toolTipListener = () => {
//         this.setState({
//             updateToolTipStatus: true
//         })
//     }
//     public pagesSwitch = (e: any, viewPage: ViewPageType) => {

//         // 审核中不能点击购物车
//         if (viewPage === 'shoppingCartPage' && Store.getState().approvalStatus === 'REVIEW') {
//             this.messengerModule.say({
//                 message: `${i18n.t('menu_page_text_under_review_wait')}`,
//                 level: "Warning",
//             });
//             return;
//         }
//         if (viewPage === 'shoppingCartPage' && Store.getState().approvalStatus === 'APPROVED') {
//             // 审核通过，点击购物车关闭已解锁
//             this.setState({
//                 setToolTip: false
//             })
//         }

//         this.setState({ viewPage });
//         Store.dispatch({
//             type: 'SET_CACHING',
//             path: 'viewPage',
//             value: viewPage
//         })

//         if (viewPage !== 'menuPage') {
//             Store.dispatch({
//                 type: 'SET',
//                 path: 'foodBarMode',
//                 value: 'MULTIPLE'
//             })
//         }

//     }

//     // 更新提示状态
//     updateToolTip = () => {
//         // 审核通过弹出购物车已解锁
//         this.setState({
//             setToolTip: true
//         }, () => {
//             setTimeout(this.handleTooltipClose, 2500)
//         })

//     }

//     // 关闭已解锁
//     handleTooltipClose = () => {
//         this.setState({
//             setToolTip: false
//         })
//     }

//     // *********************
//     // 视图区
//     // *********************

//     public render() {
//         const { viewPage, setToolTip, zoomIn } = this.state;
//         const { foodBarMode } = this.props;
//         const guidePageHideDishes = StateManager.getFromCache('guidePageHideDishes');
//         return (
//             <div className={foodBarMode === 'MULTIPLE' ? 'bottomIcon' : 'bottomIcon active'}>
//                 {foodBarMode === 'MULTIPLE' ? (
//                     <BottomNavigation value={viewPage} onChange={(e, value) => this.pagesSwitch(e, value)}>
//                         <BottomNavigationAction value="homePage" icon={
//                             <GuideTooltips
//                                 onClose={() => {
//                                 }}
//                                 placement="top"
//                                 arrow
//                                 open={guidePageHideDishes}
//                                 title={i18n.t('novice_guide_text_home')}
//                                 toopTipStyle={{
//                                     popperIndex: this.state.updateToolTipStatus,
//                                     height: 30,
//                                 }}
//                             >
//                                 <img src={HomePageIcon} alt="主页" width="24" />
//                             </GuideTooltips>
//                         } />
//                         <BottomNavigationAction value="menuPage" icon={
//                             <GuideTooltips
//                                 onClose={() => {
//                                 }}
//                                 placement="top"
//                                 arrow
//                                 open={guidePageHideDishes}
//                                 title={i18n.t('novice_guide_text_order')}
//                                 toopTipStyle={{
//                                     popperIndex: this.state.updateToolTipStatus,
//                                     height: 30,
//                                     maxWidth: 60
//                                 }}
//                             >
//                                 <img src={menuPageIcon} alt="菜单" width="24" />
//                             </GuideTooltips>
//                         } />
//                         <BottomNavigationAction className={`${!guidePageHideDishes ? 'hide-ripple' : ''}`}
//                             style={{ opacity: !!zoomIn ? 1 : 0.7 }} value="shoppingCartPage"
//                             icon={
//                                 guidePageHideDishes ?
//                                     <GuideTooltips
//                                         onClose={() => {
//                                         }}
//                                         placement="top"
//                                         arrow
//                                         open={guidePageHideDishes}
//                                         title={i18n.t('novice_guide_text_cart')}
//                                         toopTipStyle={{
//                                             popperIndex: this.state.updateToolTipStatus,
//                                             height: 30,
//                                         }}
//                                     >
//                                         <img src={orderCartIcon} alt="购物车" width="24" />
//                                     </GuideTooltips> :
//                                     <div>
//                                         <Zoom
//                                             in={!!zoomIn}
//                                             timeout={{
//                                                 enter: 300,
//                                                 exit: 300
//                                             }}
//                                             style={{
//                                                 transitionDelay: `${zoomIn ? 300 : 0}ms`,
//                                             }}
//                                             unmountOnExit
//                                         >
//                                             <Fab aria-label={'购物车'} style={{
//                                                 background: '#00cccc',
//                                                 border: '4px solid #3f4e86',
//                                                 position: 'absolute',
//                                                 left: 'calc(50% - 28px)',
//                                                 top: 'calc(50% - 36px)'
//                                             }}>
//                                                 <Badge className='footer-bar-badge-total' overlap='rectangle' badgeContent={zoomIn}>
//                                                     <img src={orderCartIcon} alt="购物车" width="24" />
//                                                 </Badge>
//                                             </Fab>
//                                         </Zoom>
//                                         <Zoom
//                                             in={!zoomIn}
//                                             timeout={{
//                                                 enter: 300,
//                                                 exit: 300
//                                             }}
//                                             style={{
//                                                 transitionDelay: `${!zoomIn ? 300 : 0}ms`,
//                                             }}
//                                             unmountOnExit
//                                         >
//                                             <Fab aria-label={'购物车'} style={{
//                                                 background: 'transparent',
//                                                 position: 'absolute',
//                                                 left: 'calc(50% - 28px)',
//                                                 top: 'calc(50% - 28px)',
//                                                 boxShadow: 'unset'
//                                             }} >
//                                                 <img src={orderCartIcon} alt="购物车" width="24" />
//                                             </Fab>
//                                         </Zoom>
//                                     </div>
//                                 // : <CustomizedTooltips
//                                 //     onClose={this.handleTooltipClose}
//                                 //     placement="top"
//                                 //     arrow
//                                 //     disableFocusListener
//                                 //     disableHoverListener
//                                 //     disableTouchListener
//                                 //     open={setToolTip}
//                                 //     title={i18n.t('menu_page_text_order_unlocked')}
//                                 // >
//                                 //     <img src={orderCartIcon} alt="购物车" width="24" />
//                                 // </CustomizedTooltips>
//                             } />

//                         <BottomNavigationAction value="orderHistory" icon={
//                             <GuideTooltips
//                                 onClose={() => {
//                                 }}
//                                 placement="top"
//                                 arrow
//                                 open={guidePageHideDishes}
//                                 title={i18n.t('novice_guide_text_history')}
//                                 toopTipStyle={{
//                                     popperIndex: this.state.updateToolTipStatus,
//                                     height: 30,
//                                     maxWidth: 60
//                                 }}
//                             >
//                                 <HistoryIcon />
//                             </GuideTooltips>
//                         } />
//                         <BottomNavigationAction value="callWaiter" icon={
//                             <GuideTooltips
//                                 onClose={() => {
//                                 }}
//                                 placement="top"
//                                 arrow
//                                 open={guidePageHideDishes}
//                                 title={i18n.t('novice_guide_text_call')}
//                                 toopTipStyle={{
//                                     popperIndex: this.state.updateToolTipStatus,
//                                     height: 30,
//                                     maxWidth: 60
//                                 }}
//                             >
//                                 <img src={callWaiterIcon} alt="呼叫服务员" width="24" />
//                             </GuideTooltips>
//                         } />
//                     </BottomNavigation>
//                 )
//                     :
//                     <BottomNavigation value={viewPage} onChange={(e, value) => this.pagesSwitch(e, value)}>
//                         <BottomNavigationAction value="shoppingCartPage" icon={
//                             <CustomizedTooltips
//                                 onClose={this.handleTooltipClose}
//                                 placement="top"
//                                 arrow
//                                 disableFocusListener
//                                 disableHoverListener
//                                 disableTouchListener
//                                 open={setToolTip}
//                                 title={i18n.t('menu_page_text_order_unlocked')}
//                             >
//                                 <img src={orderCartIcon} alt="购物车" width="24" />
//                             </CustomizedTooltips>
//                         }
//                         />
//                     </BottomNavigation>
//                 }
//             </div>

//         );
//     }

// }

export default withSnackbar(FooterBar);

// *********************
// Types
// *********************

type ViewPageType = 'menuPage' |
    'noticePage' |
    'shoppingCartPage' |
    'orderHistory' |
    'adPage' |
    'callWaiter' |
    'homePage';

type State = {
    footerNavList: Array<object>
    viewPage: string
    // 购物车已解锁弹出提示
    setToolTip: boolean
    updateToolTipStatus: boolean
    zoomIn: number;
    isUpdateCartAnimate: boolean;
}

type Props = {
    // 底部导航栏模式
    foodBarMode: 'MULTIPLE' | 'SINGLE',
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED';
    // 顾客选择的编号
    customer: string;
    onSetCartDrawer: (flag: boolean) => void;
} & WithSnackbarProps
